/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Per_Job_TitleInputs */

const en_admin_statistics_per_job_title = /** @type {(inputs: Admin_Statistics_Per_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applications per job position`)
};

const de_admin_statistics_per_job_title = /** @type {(inputs: Admin_Statistics_Per_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungen pro Stelle`)
};

/**
* | output |
* | --- |
* | "Applications per job position" |
*
* @param {Admin_Statistics_Per_Job_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_per_job_title = /** @type {((inputs?: Admin_Statistics_Per_Job_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Per_Job_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_per_job_title(inputs)
	return en_admin_statistics_per_job_title(inputs)
});